<template>
  <div class="MainStepsForm">
    <div class="container">
      <a-alert message="平台为你自行上传的作品进行版权登记，不对您上传内容的真实性进行验证" type="warning" show-icon />
      <a-alert v-if="showAlert" type="info" show-icon closable @close="alertClose" style="margin-top: 16px;">
        <template #message>
          <div class="alert-content">
            <div class="alert-title">
              关于湖北省数字版权综合服务平台开通数据增值服务付费业务的通知
            </div>
            <div class="alert-desc-wrapper">
              <span class="alert-desc">
                为持续优化湖北省数字版权综合服务平台（以下简称"平台"）服务功能、提升平台运营质量、保障系统稳定运维与技术迭代升级，为广大用户提供更专业、高效、安全的数字化服务支撑，经统筹规划、审慎研究，平台自即日起开通数据增值服务付费业务。
              </span>
              <a-button type="link" class="detail-btn" @click="handleViewDetail">
                查看详情
              </a-button>
            </div>
          </div>
        </template>
      </a-alert>

      <div class="commonWhiteBg">
        <!-- <div class="ant-popover-arrow"></div> -->
        <div class="title">版权登记</div>

          <el-form ref="form" :model="form" :rules="rules" label-width="125px" v-loading="isLoading" :element-loading-text="loadingText">
            <div class="formTitle">权利人信息</div>
            <a-row>
              <a-col :md="24" :lg="8" :xl="8">
                <el-form-item label="著作权人" prop="right">
                  <!-- <span class="rightText" v-for="(author, index) in form.right" :key="index">{{author.obligeeType == "1"? author.userName : author.companyName}}&nbsp;</span>
                  <el-button type="text" @click="isRightDialogVisible = true" :disabled="stepIdx=='2'">选择著作权人</el-button>
                  <choose-person-dialog
                      title="选择著作权人"
                      v-if="isRightDialogVisible"
                      v-model="form.right"
                      :listOpt="obligees"
                      :linkObj="{ label: '添加著作权人', path: '/Mine/Obligee' }"
                      @close="onSetRightDialogClose"
                      @input="onChooseRight"
                  ></choose-person-dialog> -->
                  <el-select v-model="selectObligee" filterable clearable placeholder="选择著作权人" @change="onChooseRight" :disabled="stepIdx=='2'" remote :remote-method="debouncedSearchObligee" @focus="handleFocus" @clear="handleClear">
                    <!-- <el-option v-for="(item, index) in obligees" :key="index" :label="item.userName || item.companyName" :value="item.userName || item.companyName"> -->
                    <el-option v-for="(item, index) in obligees" :key="index" :value="item.userName || item.companyName">
                       <span v-if="item.userName">
                        {{ item.userName }}
                        <small v-if="item.uniqueCode" style="font-size: 12px; color: #999;">
                          ({{ item.uniqueCode.slice(-4) }})
                        </small>
                      </span>
                      <span v-else>
                        {{ item.companyName }}
                      </span>
                    </el-option>
                  </el-select>
                </el-form-item>
              </a-col>
              <a-col :md="24" :lg="8" :xl="8">
                <el-form-item label="作者署名方式" prop="rightSame">
                  <el-radio-group v-model="rightSame" @change="changeRightSame" :disabled="stepIdx=='2'">
                    <el-radio label="1">本名</el-radio>
                    <el-radio label="2">别名</el-radio>
                  </el-radio-group>
                </el-form-item>
              </a-col>
              <a-col :md="24" :lg="8" :xl="8">
                <div v-for="(item,index) in form.authors" :key="index">
                  <el-form-item label="署名" :prop="'authors['+index+'].signatureName'" :rules="{ required: true, message: '请输入署名', trigger: 'blur' }" v-if="rightSame == 2">
                    <el-input placeholder="请输入署名" v-model="item.signatureName" :disabled="stepIdx=='2'"></el-input>
                  </el-form-item>
                </div>
              </a-col>
            </a-row>
            

            <div class="formTitle">作品信息</div>
            <a-row>
              <a-col :md="24" :lg="8" :xl="8">
                <el-form-item label="作品名称" prop="subject">
                  <el-input placeholder="请输入作品名称" v-model="form.subject" :disabled="stepIdx=='2' || type=='edit'"></el-input>
                </el-form-item>
              </a-col>
            </a-row>
            <el-form-item label="上传作品" ref="uploader" class="uploadWraper" prop="files">
            <el-upload  class="Uploader" :limit="1" :action="uploadUrl" :headers="uploadHeaders" :on-exceed="uploadExceed" :on-success="uploadSuccess" :on-remove="(file, fileList) => {handleRemove(file, fileList)}"
                :before-upload="uploadBefore" multiple :file-list="fileList" :disabled="stepIdx=='2'">
              <el-button type="primary" :disabled="stepIdx=='2'">⬆️ 上传作品文件</el-button>
            </el-upload>
            <!-- <p class="tipsText" type="warning">支持扩展名：.doc .docx .pdf .jpg .png ...</p> -->
            <el-button type="primary" @click="handleOpenCollageDialog" class="mergeImagesBtn">🧩 多图拼接</el-button>
            </el-form-item>

            <a-row>
              <a-col :md="24" :lg="8" :xl="8">
                <el-form-item label="作品创作类型" prop="worksType">
                  <el-select v-model="worksTypeText" placeholder="请选择创作类型" @change="selectWorksType" :disabled="stepIdx=='2'">
                      <el-option v-for="(item, index) in constants.worksType" :key="index" :label="item.label" :value="item"></el-option>
                  </el-select>
                </el-form-item>
              </a-col>
              <a-col :md="24" :lg="8" :xl="8">
                <el-form-item label="作品创作性质" prop="worksType">
                  <el-select v-model="creationNatureText" placeholder="请选择创作性质" @change="selectCreationNature" :disabled="stepIdx=='2'">
                    <el-option v-for="(item, index) in constants.creationNature" :key="index" :label="item.label" :value="index"></el-option>
                  </el-select>
                </el-form-item>
              </a-col>
            </a-row>

            <a-row>
              <a-col :md="24" :lg="8" :xl="8">
                <el-form-item label="创作完成时间" prop="finishTime">
                  <el-date-picker v-model="form.finishTime" placeholder="选择日期时间" type="date" format="yyyy-MM-dd" value-format="timestamp" :picker-options="pickerOptionsStart" @change="handleDateChange" @paste.native="e => handlePaste(e, 'finishTime')" :disabled="stepIdx=='2'"></el-date-picker>
                </el-form-item>
              </a-col>
              <a-col :md="24" :lg="8" :xl="8">
                <el-form-item label="创作完成地点" prop="province">
                  <china-area-data :areaData="areaData1" @change="selectArea" :disabled="stepIdx=='2'"></china-area-data>
                </el-form-item>
              </a-col>
              <a-col :md="24" :lg="8" :xl="8"></a-col>
            </a-row>

            <a-row>
              <a-col :md="24" :lg="8" :xl="8">
                <el-form-item label="作品发表状态" prop="publishStatus">
                  <el-select v-model="publishStatusText" placeholder="请选择作品发表状态" @change="selectPublishStatus" :disabled="stepIdx=='2'">
                      <el-option v-for="(item, value) in constants.publishStatus" :key="value" :label="item.label" :value="value"></el-option>
                  </el-select>
                  </el-form-item>
              </a-col>
              <a-col :md="24" :lg="8" :xl="8">
                <el-form-item label="首次发表时间" prop="publishTime" v-if="form.publishStatus == 2">
                  <el-date-picker v-model="form.publishTime" placeholder="选择日期时间" type="date" format="yyyy-MM-dd" value-format="timestamp" :picker-options="pickerOptionsEnd" @paste.native="e => handlePaste(e, 'publishTime')" :disabled="stepIdx=='2'"></el-date-picker>
                </el-form-item>
              </a-col>
              <a-col :md="24" :lg="8" :xl="8">
                <el-form-item label="发表地点" prop="province2" v-if="form.publishStatus == 2">
                  <china-area-data :areaData="areaData2" @change="selectArea2" :disabled="stepIdx=='2'"></china-area-data>
                </el-form-item>
              </a-col>
            </a-row>

            <a-row>
              <a-col :md="24" :lg="12" :xl="12">
                <el-form-item label="内容简介" prop="creationIntention.text">
                  <el-input type="textarea" :rows="5" placeholder="请输入内容简介" v-model="form.creationIntention.text" :disabled="stepIdx=='2'"></el-input>
                </el-form-item>
              </a-col>
              <a-col :md="24" :lg="12" :xl="12">
                <a-alert class="tips" type="warning">
                  <div slot="message">温馨提示：</div>
                  <div slot="description">
                  请填写中心内容及作品特点：对作品进行简述，包括主要内容、章节编排、部分划分、与同类作品相比的独特之处等。如美术作品需对作品本身的表现形式和审美特征进行描述（颜色、形态、表情等）。(注：若提交的作品样本中含有外文请在内容简介中附中文解释。)
                  </div>
                </a-alert>
              </a-col>
            </a-row>

            <a-row>
              <a-col :md="24" :lg="12" :xl="12">
                <el-form-item label="创作过程" prop="creationProcess.text">
                  <el-input type="textarea" :rows="5" placeholder="请输入创作过程" v-model="form.creationProcess.text" :disabled="stepIdx=='2'"></el-input>
                </el-form-item>
              </a-col>
              <a-col :md="24" :lg="12" :xl="12">
                <a-alert class="tips" type="warning">
                  <div slot="message">温馨提示：</div>
                  <div slot="description">
                  （1）创作过程：创作意图，策划和准备，创作方式（手绘、使用电脑、具体的艺术手法、软件及具体操作等），经过几次修改，每次都修改了哪些内容。 （2）使用情况：发表情况、许可他人专有使用情况。 （注：摄影作品须在创作过程中写明具体拍摄设备、光圈值、快门等详细参数。）
                  </div>
                </a-alert>
              </a-col>
            </a-row>

            <el-form-item label="其它证明材料" prop="ownershipPicture.additionalProp2">
              <div class="uploadBusinessLicense">
                <el-upload class="Uploader" :limit="1" :action="uploadUrl"  :headers="uploadHeaders" :on-exceed="uploadExceed2" :on-success="uploadSuccess2" :on-remove="(file, fileList2) => {handleRemove2(file, fileList2)}"
                :before-upload="uploadBefore2" :on-preview="previewImg" multiple :file-list="fileList2" :disabled="stepIdx=='2'">
                  <el-button type="primary" :disabled="stepIdx=='2'"><i class="iconfont iconUpload">&#xe606;</i>上传附件资料</el-button>
                </el-upload>
              </div>
            </el-form-item>

            <div class="formTitle formTitle2"></div>
            <el-form-item label="办理时限" prop="processingTime">
              <el-radio-group v-model="form.extra.processingTime" @change="changeProcessingTime" :disabled="stepIdx=='2' || type == 'edit'">
                <el-radio label="15" v-if="stepIdx=='1' || form.extra.processingTime == '15'">15个工作日(正常)</el-radio>
                <el-radio label="5" v-if="stepIdx=='1' || form.extra.processingTime == '5'">5个工作日(加急档)</el-radio><br>
                <!-- <el-radio label="3" v-if="stepIdx=='1' || form.extra.processingTime == '3'">3个工作日(加急档)</el-radio>
                <el-radio label="1" v-if="stepIdx=='1' || form.extra.processingTime == '1'">1个工作日(加急档)</el-radio> -->
              </el-radio-group>
            </el-form-item>

            <el-form-item label="支付方式" prop="payStyle" class="choosePayStyle">
              <el-radio-group v-model="form.paymode" @change="chengePaymode" :disabled="stepIdx=='2'">
                <el-radio label="vip" v-if="stepIdx=='1' || form.paymode == 'vip'">
                  <span class="onlyText" v-if="vipInfo&&vipInfo.vipType=='C'"> 会员权益支付（当前登记次数可用
                    <span v-if="form.extra.processingTime == '15'">{{vipInfo ? vipInfo.detectCount : 0}}</span>
                    <span v-if="form.extra.processingTime == '5'">{{vipInfo ? vipInfo.registerCount : 0}}</span>
                    <span v-if="form.extra.processingTime == '3'">{{vipInfo ? vipInfo.existCount : 0}}</span>
                      <span v-if="form.extra.processingTime == '1'">{{vipInfo ? vipInfo.obtainCount : 0}}</span>
                    次）</span>
                  <span class="onlyText" v-else> 会员权益支付（当前登记次数可用{{vipInfo ? vipInfo.registerCount : 0}}次）</span>
                </el-radio>
                <!-- <el-radio label="alipay" v-if="stepIdx=='1' || form.paymode == 'alipay'"><i class="iconfont aliPayColor"> &#xe675; </i><span>支付宝支付</span></el-radio>
                <el-radio label="wechat" v-if="stepIdx=='1' || form.paymode == 'wechat'"><i class="iconfont weChatColor"> &#xe64f; </i><span>微信支付</span></el-radio> -->
              </el-radio-group>
            </el-form-item>
            <el-form-item label="支付金额" v-if="form.paymode != 'vip' && stepIdx=='2'" class="payMount">
              <div><em class="bigPrice"> {{ orderAmount }} </em> 元</div>
            </el-form-item>
            <el-form-item prop="agreement" style="margin-bottom: 30px;padding-left: 125px;">
              <el-checkbox-group v-model="agreement" >
                <el-checkbox>我已阅读<span @click.stop="registerEquirements($event)">《登记须知》</span></el-checkbox>
              </el-checkbox-group>
            </el-form-item>

            <el-form-item class="submitRow">
              <el-button type="primary" @click="reset" v-if="stepIdx==1">重置</el-button>
              <el-button type="primary" @click="next" v-if="stepIdx==1">下一步</el-button>
              <el-button type="primary" @click="prev" v-if="stepIdx==2">返回修改</el-button>
              <el-button type="primary" @click="onSubmit('register')" v-if="stepIdx==2 && type=='register'">提交信息</el-button>
              <el-button type="primary" @click="onSubmit('edit')" v-if="stepIdx==2 && type=='edit'">修改订单</el-button>
            </el-form-item>

          </el-form>

      </div>
    </div>

    <!-- 图片预览 -->
      <el-image-viewer
          v-if="showImageViewer"
          :url-list="[showImageUrl]"
          hide-on-click-modal
          teleported
          :on-close="closePre"
      />

    <pay-dialog ref="payDialog" payForm="register" @close="onSetPayDialogClose"></pay-dialog>

    <!-- 《登记须知》弹窗 -->
    <RegisterEquirements-Dialog ref="registerEquirementsDialog"></RegisterEquirements-Dialog>

    <!-- 多图拼接弹窗 -->
    <el-dialog
      title="📸 多图拼接"
      :visible.sync="showCollageDialog"
      width="95%"
      top="2vh"
      :before-close="handleClose"
      destroy-on-close
      class="collage-dialog"
      custom-class=“mergeImagesDialog”
    >
      <MergeImages @use-collage="handleUseCollage" />
    </el-dialog>
  </div>
</template>

<script>
import { debounce } from 'lodash'
import { queryExistOrderItems,applyRegisterOrder,queryDuplicate,editRegister } from "@/api/EvidenceService";
import { queryObligeeList,searchObligee } from "@/api/ObligeeService";
import multipleSelect from "../../../components/form/multipleSelect";
import choosePersonDialog from "../../../components/form/choosePersonDialog";
import ChinaAreaData from "@/components/ChinaAreaData";
import { mapGetters } from "vuex";
import { mixinsScrollErrorPosition } from "../../../mixins";
import constants from "@/utils/constants";
import PayDialog from "../../../components/PayDialog";
import RegisterEquirementsDialog from "../../../components/RegisterEquirementsDialog"
import request from '@/utils/request'
import MergeImages from "../../../components/MergeImages"

export default {
  name: "RegisterInputForm",
  mixins: [mixinsScrollErrorPosition],
  components: {
    multipleSelect,
    choosePersonDialog,
    ChinaAreaData,
    PayDialog,
    RegisterEquirementsDialog,
    'el-image-viewer': () => import('element-ui/packages/image/src/image-viewer'),
    MergeImages
  },
  data() {
    return {
      type: 'register', // register 正常登记， edit 修改订单
      orderNo: '',
      originalRightCode: '', // 存储修改之前 原始著作权人code
      originalSubject: '',   // 存储修改之前 原始作品名称

      constants,
      stepIdx: "1",

      obligees: [],
      uploadUrl:`${process.env.VUE_APP_BASEURL}/v1/ins/file/upload?path=register/evidence/files/`,
      uploadHeaders:{ 
        'Authorization': this.$store.getters.token,
        'Product-Mode': "READ",
        'Terminal-Code': "IPCHAIN2"+ this.$store.getters.terminalCode,
        'Terminal-Type': "WEB",
        'Merchant-Id': "5"
      },
      fileList: [],
      uploadControllers: {},  // 修改为对象存储，key为文件uid，value为对应的控制器
      worksTypeText: '',
      creationNatureText: '',
      publishStatusText: '',
      fileList2: [],  // 其它证明材料
      uploadControllers2: {},  // 其它证明材料的分片上传控制器
      areaData1: {},
      areaData2: {},
      orderAmount: 0,
      rightSame: "1",
      selectObligee: null,
      form: {
        paymode: 'vip',
        right: [],
        creationNature: "1",
        creationPropertyDesc:{
          text:"",
        },
        finishTime: "",
        creationIntention:{
          text:"",
        },
        creationProcess:{
          text:"",
        },
        province: "",
        city: "",
        publishStatus: "",
        province2: "",
        city2: "",
        publishTime: "",
        subject: "",
        worksType: "",
        files: [],
        ownership: "1",
        obtainType: "1",
        authors: [
          {name:"",signatureType:"1",signatureName:"",orders:1},
        ],
        obtainTypeDesc: {
          text:"",
        },
        ownershipPicture: {
          "additionalProp1": "",
          "additionalProp2": "",
          "additionalProp3": "",
          "additionalProp4": "",
          "additionalProp5": "",
          "additionalProp6": "",
        },
        rightHave: ["1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12", "13", "14", "15", "16", "17"],
        extra: {
          processingTime: '5',
        },
        orderType: '02',
      },
      showImageViewer: false,
      showImageUrl: '',
      isLoading: false,
      loadingText: '正在提交，请稍候...',
      rules: {
        right: [
          { required: true, message: "请选择著作权人", trigger: "blur" },
          {
            validator: (rule, value, callback) => {
              if (value && value.includes(null)) {
                callback(new Error("著作权人错误"));
              } else {
                callback();
              }
            },
            trigger: "blur"
          },
          { 
            // 著作权人过期验证
            validator: (rule, value, callback) => {
              const today = Math.floor(Date.now() / 1000);
              if (this.form.right[0].longValid==2 && this.form.right[0].expireDate && this.form.right[0].expireDate < today) {  //longValid==2表示非长期
                // 如果已过期，返回错误提示
                callback(new Error('著作权人证件已过期，请检查有效日期'));
              } else {
                callback(); // 不满足条件，跳过此验证
              }
            },
            trigger: "blur",
          },
        ],
        subject: [
          { required: true, message: '请输入作品名称', trigger: "blur" },
          { min: 1, max: 50, message: "长度在 1 到 50 个字符", trigger: "blur",},
          { 
            validator: (rule, value, callback) => {
              // let subjectName = this.form.subject.replace(/[\u00A0\s"`~!@#$%^&*()+=|{}':;',\[\].<>\/?~！@#￥%……&*（）——+|{}【】‘；：”“'。，、？]/g, '', '');  // 正则替换掉特殊符号              
              let subjectName = this.form.subject;
              if(this.form.files.length > 0 && subjectName != this.form.files[0].sourceName){
                callback(new Error("作品名称须与上传样本文件名称保持一致"));
              }
               // 如果是edit类型，说明是初审或者终审驳回件，直接通过验证，不需要下面的重名验证
              if (this.type === 'edit') {
                return callback();
              }
              // 异步验证示例
              queryDuplicate({subject: this.form.subject}).then(data => {
                data.data.duplicate ? callback(new Error('经查询作品名称重复')) : callback();
              }).catch(error => {
                this.isLoading = false; // 出错时也关闭loading
                console.error('验证接口出错:', error);
                // callback(); // 可以选择继续表单验证或调用callback(new Error('验证失败')) // 这里放行了表单提交！
                callback(new Error(`验证服务异常: ${error.message || '未知错误'}`)); // 拦截提交
              });
            },
            trigger: "blur"
          },
        ],
        province: [
          { required: true, validator: this.valiCity, trigger: "blur" },
        ],
        province2: [
          { required: true, validator: this.valiCity2, trigger: "blur" },
        ],
        files: [
          { required: true, message: "请上传作品", trigger: "blur" },
        ],
        worksType: [
          { required: true, message: "请选择作品创作类型", trigger: "blur" },
        ],
        finishTime: [
          { required: true, message: "请选择创作完成时间", trigger: "blur" },
          { 
            // 如果选择的是企业著作权人，则选择的完成日期，必须在企业著作权人的证件有效期的开始日期之后；
            //如果this.form.right不为[]，而且 this.form.right[0].obligeeType是为‘2’的时候，这个完成时间，必须在 this.form.right[0].startDate 这个时间之后。
            validator: (rule, value, callback) => {
              // 条件：right 非空，且 identityType 为 '2'
              if (this.form.right?.length > 0 && this.form.right[0].obligeeType === '2' && this.form.right[0].startDate ) {
                if (!value) {
                  callback(new Error("请选择创作完成时间"));
                  return;
                }
                // 获取 finishTime 的时间戳（兼容 Date 对象或时间戳）
                // console.log('完成时间：：：',value);
                const finishTimeStamp = typeof value === 'number' ? Math.floor(value / 1000) : Math.floor(new Date(value).getTime() / 1000); // 兼容 Date 对象或日期字符串
                const startTimeStamp = Number(this.form.right[0].startDate);
                // console.log(finishTimeStamp);
                // console.log(startTimeStamp);
                // 检查 finishTime 是否晚于 startDate
                if (finishTimeStamp <= startTimeStamp) {
                  callback(new Error("完成日期必须在法人组织成立日期之后"));
                } else {
                  callback(); // 验证通过
                }
              } else {
                callback(); // 不满足条件，跳过此验证
              }
            },
            trigger: "blur",
          },
        ],
        'creationIntention.text': [
          { required: true, message: "请输入内容简介", trigger: "blur" },
        ],
        'creationProcess.text': [
          { required: true, message: "请输入创作过程", trigger: "blur" },
        ],
        publishStatus: [
          { required: true, message: "请选择作品发表状态", trigger: "blur" },
        ],
        publishTime: [
          { required: true, message: "请选择首次发表日期", trigger: "blur" },
        ],
        agreement: [
          { required: true, validator: this.valiAgreement, trigger: "change" },
        ],
      },
      //完成日期在发表日期之前,同时不能超过当前日期
      pickerOptionsStart: {
          disabledDate: time => {
              const publishTime = this.form.publishTime;
              // 如果publishTime为空，只能选择不超过当前日期的日期
              if (!publishTime) {
                  return time.getTime() > Date.now();
              }
              // 否则，选择日期不能超过publishTime或当前日期
              return time.getTime() > new Date(publishTime).getTime() || time.getTime() > Date.now();   //-8.64e7可以让开始时间和结束时间选同一天
          }
      },
      pickerOptionsEnd: {
          disabledDate: time => {
              const finishTime = this.form.finishTime;
              // 如果finishTime为空，只能选择不超过当前日期的日期
              if (!finishTime) {
                  return time.getTime() > Date.now();
              }
              // 否则，选择日期不能早于finishTime或超过当前日期
              return time.getTime() < new Date(finishTime).getTime() || time.getTime() > Date.now();    //-8.64e7可以让开始时间和结束时间选同一天
          }
      },
      isAuthorDialogVisible: false,
      isRightDialogVisible: false,

      agreement: true, // << 登记须知 >> 默认勾选

      // 创建防抖函数，500ms内只执行一次
      debouncedSearchObligee: debounce(this.searchObligee, 500),

      // 多图拼接弹窗
      showCollageDialog: false,

      showAlert: true // 控制 alert 显示/隐藏
    };
  },
  computed: {
    ...mapGetters(["mid", "userInfo", "evidencePaymentPrice", "vipInfo","obligeeList"]),
  },
  watch: {
    form: {
      handler(newValue) {
        // 自动保存表单数据到 localStorage
        localStorage.setItem(`form02_${this.mid}`, JSON.stringify(newValue));
      },
      deep: true
    },
    'form.right': {
      handler(newValue) {
        if (newValue && newValue.length > 0) {
          // this.selectObligee = newValue[0].userName || newValue[0].companyName;
          this.selectObligee = newValue[0].userName ? newValue[0].userName+' ('+newValue[0].uniqueCode.slice(-4)+')': newValue[0].companyName;
        } else {
          this.selectObligee = null;
        }
      },
      deep: true, // 深度监听
      immediate: true, // 立即执行
    },
    // 监听vuex里面mapGetters的obligeeList的改变
    obligeeList: {
      handler(newVal, oldVal) {
        // 当 obligeeList 或其内部发生变化时执行
        // console.log('obligeeList 发生变化:', newVal, oldVal);
        // 在这里添加你的逻辑
        if(oldVal == null){ // 页面加载完，著作权人还没有加载到，后面才加载到的情况，再改倒序
          this.obligees = [...newVal];
        }else{
          this.obligees = newVal;
        }
      },
      deep: true // 深度监听
    },
    vipInfo(newVal, oldVal){
      oldVal = newVal
    },

    // 监听作品类型 针对美术和摄影，也就是"8"和"10"，的时候。 内容简介和创作过程，不是必填，清除验证
    'form.worksType': {
      handler(newVal) {
        console.log('newVal:',newVal);
        if (newVal == 8 || newVal == 10) {
          // 清除验证规则
          // this.$refs.form.clearValidate(['creationIntention.text']);
          // this.$refs.form.clearValidate(['creationProcess.text']);
          // 或设置非必填
          this.rules['creationIntention.text'][0].required = false;
          this.rules['creationProcess.text'][0].required = false;
        } else {
          this.rules['creationIntention.text'][0].required = true;
          this.rules['creationProcess.text'][0].required = true;
        }
      },
      immediate: true
    }
  },
  created() {
    // localStorage.removeItem(`form02_${this.mid}`); //测试清理缓存
    // 从 localStorage 中加载数据
    const savedData = localStorage.getItem(`form02_${this.mid}`);
    let form = {};
    if (savedData) {
      form = JSON.parse(savedData);
      if(!form.extra){ // 判断是否存在processingTime参数，若是没有，添加默认15
        form.extra = {
          processingTime: '5',
        }
      }
      // console.log(form);
      this.form = form;
    }
    if(this.$route.query.type && (this.$route.query.type == 'edit')){
      // console.log('type::::',this.$route.query.type);
      this.type = this.$route.query.type
      this.orderNo = this.$route.query.orderNo
      // 保存原始值，用于后续比较
      if (this.form.right && this.form.right.length > 0) {
        this.originalRightCode = this.form.right[0].obligeeCode;
      }
      this.originalSubject = this.form.subject;
    }else{  // 如果不是修改订单，是新建订单或者复制订单，则清空ownershipPicture里面的additionalProp2以外的其他参数
      this.form.ownershipPicture = {
        "additionalProp1": "",
        "additionalProp2": this.form.ownershipPicture.additionalProp2,
        "additionalProp3": "",
        "additionalProp4": "",
        "additionalProp5": "",
        "additionalProp6": "",
      }
      localStorage.setItem(`form02_${this.mid}`, JSON.stringify(this.form));
    }

    this.loadData();

    // 默认地址
    this.areaData1 = {
      province: this.form.province,
      city: this.form.city,
    },
    this.areaData2 = {
      province: this.form.province2,
      city: this.form.city2,
    }

    // 获取缓存里面信息转化
    if(this.form.authors[0].signatureType == '2'){  // 别名
      this.rightSame  = '2'
    }
    if(this.form.worksType){
      // console.log(this.form.worksType);
      const found = this.constants.worksType.find(item => item.value === this.form.worksType);
      if(found){
        this.worksTypeText = found.label
      }
    }
    if(this.form.files){
      let arr = []
      for(let i=0;i<this.form.files.length;i++){
        arr.push({
          name: this.form.files[i].sourceName+'.'+this.form.files[i].fileType,
          url: this.form.files[i].downloadUrl,
        })
      }
      this.fileList = arr
    }
    //获取缓存里面信息转化,默认原创
    if(this.form.creationNature){
      this.creationNatureText = this.constants.creationNature[this.form.creationNature * 1 - 1].label;
    }else{
      this.form.creationNature = '1';
      this.creationNatureText = '原创';
    }
    // 获取缓存里面信息转化,默认未发表
    if(this.form.publishStatus){
      this.publishStatusText = this.constants.publishStatus[this.form.publishStatus * 1 - 1].label;
    }else{
      this.form.publishStatus = '1';
      this.publishStatusText = '未发表';
    }
    if(this.form.ownershipPicture.additionalProp2){
      let arr = []
      var lastSlashIndex = this.form.ownershipPicture.additionalProp2.lastIndexOf('/');  // 截取图片url上的文件名
      var fileName = this.form.ownershipPicture.additionalProp2.substring(lastSlashIndex + 1);
      arr.push({
        name: fileName,
        url: this.form.ownershipPicture.additionalProp2,
      })
      this.fileList2 = arr
    }

    // 有会员的默认选,会员支付方式
    setTimeout(()=>{
      if(this.vipInfo && this.vipInfo.vipType != 'C' && this.vipInfo.registerCount > 0 && this.stepIdx == '1'){
        this.form.paymode = 'vip';
      }else if(this.vipInfo && this.vipInfo.vipType != 'C' && this.vipInfo.registerCount == 0 && this.stepIdx == '1'){
        this.$message.warning("会员权益支付登记可用次数为0")
      }
    },300)

    // 打开页面请求会员权益信息
    this.bus.$emit("refreshVip");
    
  },
  methods: {
    loadData() {
      if (this.mid) {
        // 打开页面更新一下著作权人
        // queryObligeeList(1, 50).then(({ data }) => {
        //   // console.log('zhuzuoquanren:',data.list);
        //   if (data && data.list.length > 0) {
        //     this.$store.commit("setObligeeList", data.list); // 默认倒序
        //   }
        // });
        this.getAllObligeeData().then(allData => {
          if (allData && allData.length > 0) {
            this.$store.commit("setObligeeList", allData);
          }
        });
      }
      if(this.obligeeList){
        // console.log(this.obligeeList);
        this.obligees = this.obligeeList;
      }else{
        this.$message.error("获取著作权人列表失败")
        // 如果数据还未加载完成，可以设置监听或延迟检查
        const timer = setInterval(() => {
            if (this.obligeeList) {
                this.obligees = this.obligeeList;
                clearInterval(timer);
            }
        }, 100);
      }
    },
// 循环版本
async getAllObligeeData() {
  const pageSize = 50;
  let page = 1;
  let allData = [];
  
  try {
    // 先获取第一页数据，知道总数
    const firstResponse = await queryObligeeList(page, pageSize);
    
    if (!firstResponse.data || !firstResponse.data.list) {
      return [];
    }
    
    allData = allData.concat(firstResponse.data.list);
    
    // 计算总页数
    const total = firstResponse.data.total;
    const totalPages = Math.ceil(total / pageSize);
    
    // 如果有多页数据，并行请求剩余页（可选，也可以串行）
    if (totalPages > 1) {
      const pagePromises = [];
      
      for (let i = 2; i <= totalPages; i++) {
        pagePromises.push(queryObligeeList(i, pageSize));
      }
      
      // 等待所有请求完成
      const responses = await Promise.all(pagePromises);
      
      responses.forEach(response => {
        if (response.data && response.data.list) {
          allData = allData.concat(response.data.list);
        }
      });
    }
    
    return allData;
  } catch (error) {
    console.error('获取著作权人数据失败:', error);
    return allData; // 返回已获取的数据
  }
},
    calAmount() {  // 计算价格
      // let amount = 0;
      // let registerConfig = this.evidencePaymentPrice.register;
      // amount = registerConfig.amount * 1;

      // this.orderAmount = amount;

      let amount = 0;
      let registerConfig;
      if(this.form.extra.processingTime == '1'){
        registerConfig = this.evidencePaymentPrice.register.read.d1;
      }else if(this.form.extra.processingTime == '3'){
        registerConfig = this.evidencePaymentPrice.register.read.d3;
      }else if(this.form.extra.processingTime == '5'){
        registerConfig = this.evidencePaymentPrice.register.read.d5;
      }else if(this.form.extra.processingTime == '15'){
        registerConfig = this.evidencePaymentPrice.register.read.d15;
      }
      amount = registerConfig.amount * 1;

      this.form.orderAmount = amount;
    },
    onSetAuthorDialogClose() {
      this.isAuthorDialogVisible = false;
    },
    onSetRightDialogClose() {
      this.isRightDialogVisible = false;
    },
    onChooseAuthor(users) {
      this.form.author = users;
    },
    onChooseRight(users) {
      if (!users) { // clear 时，清空数据
        this.form.right = [];    // 清空表单数据
      }else{
        const selectedObligeeObject = this.obligees.find(
          item => (item.userName || item.companyName) === users
        );
        this.form.right = [selectedObligeeObject];
        this.selectObligee = users;
        this.rightSame = '1'; // 修改著作人之后 这里自动弹回本名
        if(this.rightSame == "1"){ // 作者同著作权人（本名）
          if(this.form.right[0].obligeeType == '1'){
            this.form.authors = [{name: this.form.right[0].userName,signatureType:"1",signatureName: this.form.right[0].userName,orders:1}];
          }else{
            this.form.authors = [{name: this.form.right[0].companyName,signatureType:"1",signatureName: this.form.right[0].companyName,orders:1}];
          }
        }else if(this.rightSame == "2"){
           if(this.form.right[0].obligeeType == '1'){
            this.form.authors = [{name: this.form.right[0].userName,signatureType:"2",signatureName: '',orders:1}];
          }else{
            this.form.authors = [{name: this.form.right[0].companyName,signatureType:"2",signatureName: '',orders:1}];
          }
        }
        this.$refs.form.validateField('right');
      }
    },
    // 输入搜索著作权人
    async searchObligee(query){
      if (query !== '') {
        try {
          // 调用API接口，query是用户输入的搜索词
          let params = {
            obligeeName: query
          }
          searchObligee(params).then(({data})=>{
            // console.log(data.list);

            // 将搜索的结果，与this.obligeeList对比，如果不存在，则添加进本地obligeeList缓存
            // console.log(this.obligeeList);
            // console.log(this.obligees);
            // 1. 获取array1中所有的obligeeCode值
            const existingCodes = this.obligeeList.map(item => item.obligeeCode);
            // 2. 找出array2中obligeeCode不在array1中的对象
            const itemsToAdd = [];
            for (const item of data.list) {
              if (!existingCodes.includes(item.obligeeCode)) {
                itemsToAdd.push(item);
              }
            }
            // 3. 将这些对象添加到obligeeList中，合并数组并更新 store
            const mergedArray = [...itemsToAdd, ...this.obligeeList];
            // 更新本地缓存
            this.$store.commit("setObligeeList", mergedArray);

            // 4. 确保 Vuex 更新完成后，并且本地监听obligeeList改变obligees之后，再手动更新 obligeesList
            this.$nextTick(() => {
              this.obligees = data.list || [];
            });
          })
        } catch (error) {
          console.error('搜索权利人失败:', error)
          this.obligees = []
        }
      } else {
        this.obligees = this.obligeeList; // 继续调用缓存的obligeeList
      }
    },
    handleFocus(){ // 获取焦点之后
      this.obligees = this.obligeeList; // 继续调用缓存的obligeeList
    },
    handleClear(){ // 清除内容之后
      this.obligees = this.obligeeList; // 继续调用缓存的obligeeList
    },
    changeRightSame(value){
      if(value == '1' && this.form.right.length > 0){ // 作者同著作权人
        if(this.form.right[0].obligeeType == '1'){
          this.form.authors = [{name: this.form.right[0].userName,signatureType:"1",signatureName: this.form.right[0].userName,orders:1}];
        }else{
          this.form.authors = [{name: this.form.right[0].companyName,signatureType:"1",signatureName: this.form.right[0].companyName,orders:1}];
        }
      }else if(value == '2' && this.form.right.length > 0){
        if(this.form.right[0].obligeeType == '1'){
          this.form.authors = [{name: this.form.right[0].userName,signatureType:"2",signatureName: '',orders:1}];
        }else{
          this.form.authors = [{name: this.form.right[0].companyName,signatureType:"2",signatureName: '',orders:1}];
        }
      }
    },
    valiCity(rule, value, callback) {
      if (!this.form.province) {
        callback(new Error("请选择省份"));
        return;
      }
      if (!this.form.city) {
        callback(new Error("请选择城市"));
        return;
      }
      // if (!this.form.area) {
      //   callback(new Error("请选择区县"));
      //   return;
      // }
      callback();
    },
    valiCity2(rule, value, callback) {
      if (!this.form.province2) {
        callback(new Error("请选择省份"));
        return;
      }
      if (!this.form.city2) {
        callback(new Error("请选择城市"));
        return;
      }
      callback();
    },
    selectArea(data) {
      // console.log(data);
      if(data.laber == 'province'){
        this.form.province = data.value;
        this.form.city = '';
      }else if(data.laber == 'city'){
        this.form.city = data.value;
      }
      this.$refs.form.validateField('province');
      this.$refs.form.validateField('city');
      // console.log(this.form.province);
      // this.form.area = data.selectData.area.name;
    },
    selectArea2(data) {
      if(data.laber == 'province'){
        this.form.province2 = data.value;
        this.form.city2 = '';
      }else if(data.laber == 'city'){
        this.form.city2 = data.value;
      }
      this.$refs.form.validateField('province2');
      this.$refs.form.validateField('city2');
      // this.form.area2 = data.selectData.area.name;
    },
    // 上传作品
    uploadBefore(file) {
        const allowedTypes = ['.jpg','.jpeg','.gif','.bmp','.png','.doc','.docx','.xls','.xlsx','.ppt','.pptx','.pdf','.txt','.wav','.mp4','.wmv','.mp3','.psd'];
        // 检查文件格式
        const ext = '.' + file.name.split('.').pop().toLowerCase();
        if (!allowedTypes.includes(ext)) {
            this.$message.error('不支持的文件格式：' + ext);
            return false;
        }
        // 检查文件大小
        if (file.size > 100 * 1024 * 1024) {
            this.$message.error('文件大小不能超过100MB');
            return false;
        }
        // 大于10MB使用分片上传
        if (file.size > 10 * 1024 * 1024) {
            // console.log("上传文件大于10M，采用分片上传");
            setTimeout(() => this.chunkUpload(file), 0);// 延迟执行，避免阻塞UI
            return false;
        }
        // 小文件：继续普通上传
        return true;
    },
    uploadExceed(){
      this.$message.warning( '只能上传一个文件');
    },
    uploadSuccess(response, file, fileList){
        if(!response){
					this.$message.error('上传失败！');
					return false
				}
        // 新增：避免重复 push
        if (this.form.files.some(f => f.downloadUrl === response.downloadUrl)) return;
        this.form.files.push(response);
        this.$refs.form.validateField('files');
        this.calAmount(); // 计算价格
    },
    handleRemove(file,fileList){
      // 中断该文件的上传（如果正在上传）
      this.abortUpload(file);
      // console.log(file);
      // 1. 获取要删除的文件名
      const name = file.response ? `${file.response.sourceName}.${file.response.fileType}` : file.name; 
      // console.log(name);
      // console.log(this.form.files);
      this.form.files = this.form.files.filter(file => {
        const fullName = file.sourceName + '.' + file.fileType;
        if (name.includes('.')) {
          return name !== fullName;  // 保留不匹配的文件，匹配的文件是删除的文件
        } else {
          return name !== file.sourceName;  // 保留不匹配的文件，匹配的文件是删除的文件
        }
      });
      this.fileList = fileList
      this.calAmount(); // 计算价格
    },

// 添加分片上传方法
async chunkUpload(file) {
  if (!file.uid) file.uid = Date.now() + '_' + Math.random().toString(36).slice(2); // 新增,如果是拼图new File() 出来的对象没有 uid。则创建一个。
  // 为当前文件创建独立的控制器
  const controller = new AbortController();
  this.uploadControllers[file.uid] = controller;
  // 检查是否已中断
  if (controller.signal.aborted) {
    throw new Error('上传已被中断');
  }
  // console.log('分片上传');
  try {
    // 1. 分片上传-1.获取上传ID /v1/ins/file/uploadId
    // 使用 Fetch API 上传
    const formData1 = new FormData()
    formData1.append('fileName', file.name)
    const randomPath = Math.random().toString(36).substring(2, 9)
    const uploadIdResponse = await fetch(`${process.env.VUE_APP_BASEURL}/v1/ins/file/uploadId?path=register/evidence/files/${randomPath}` , {
      method: "POST",
      body: formData1,
      headers: this.uploadHeaders,
    });
    if (!uploadIdResponse.ok) throw new Error('获取上传ID失败');
    
    const uploadIdData = await uploadIdResponse.json();
    const uploadId = uploadIdData.uploadId;
    console.log('分片上传ID:',uploadId);
    
    // 2. 分片上传
    const chunkSize = 5 * 1024 * 1024;
    const totalChunks = Math.ceil(file.size / chunkSize);
    const partETags = []; // 存储每个分片的ETag，第三步需要的参数

    // 在fileList中添加文件项，并保存索引以便后续更新
    const fileItem = {
      name: `${file.name} （分片上传进度：0/${totalChunks})`,
      uid: file.uid,
      rawFile: file, // 保存原始文件对象以便标识
      status: 'uploading', // 设置上传中状态
      totalChunks: totalChunks,
      uploadedChunks: 0,
      percentage: 0 // 确保有 percentage 属性，初始为0
    };
    this.fileList.push(fileItem);

    for (let i = 0; i < totalChunks; i++) {
       // 每次循环前检查是否已中断
       if (controller.signal.aborted) {
        throw new Error('上传已被中断');
      }
      const start = i * chunkSize;
      const end = Math.min(start + chunkSize, file.size);
      const chunk = file.slice(start, end);
      const currentPartNumber = i + 1;
      // 更新进度显示
      const currentFileIndex = this.findFileIndex(file);
      if (currentFileIndex !== -1) {
        const uploadedChunks = i; // 当前已上传的分片数
        this.fileList[currentFileIndex].name = `${file.name} （分片上传进度：${uploadedChunks}/${totalChunks})`;
        this.fileList[currentFileIndex].percentage = Math.round((uploadedChunks / totalChunks) * 100);
        this.fileList[currentFileIndex].uploadedChunks = uploadedChunks;
      }
      // 参数：
      // currentPartNumber Number 是 1 当前分⽚号
      // currentPartSize Number 是 1048576// 当前分⽚⼤⼩，除了最后⼀个分⽚外，// 所有分⽚的⼤⼩都应该不⼩于5M，最后⼀个// 分⽚的⼤⼩不受限制
      // partNum Number 是 4 总分⽚⼤⼩
      // offset Number 是 0 分⽚偏移量，从零开始
      // file File 是 待分⽚⽂件
      const formData2 = new FormData();
      formData2.append('currentPartNumber', currentPartNumber);
      formData2.append('currentPartSize', chunk.size);
      formData2.append('partNum', totalChunks);
      formData2.append('offset', start); // 分片偏移量，从零开始
      formData2.append('file', chunk);
      // 等待当前分片上传完成，请求接口
      const uploadResponse = await fetch(`${process.env.VUE_APP_BASEURL}/v1/ins/file/uploadPart/${uploadId}?path=register/evidence/files/${randomPath}`, {
        method: "POST",
        body: formData2,
        headers: this.uploadHeaders,
      });
      if (!uploadResponse.ok) throw new Error(`分片 ${currentPartNumber} 上传失败`);
      // 保存分片的ETag信息（根据实际接口返回字段调整）第三步需要使用的参数
      const partResult = await uploadResponse.json();
      if (partResult.eTag) {
        partETags.push({ partNumber: currentPartNumber, eTag: partResult.eTag });
      }

      // 更新进度显示（上传完成后）
      const currentFileIndex2 = this.findFileIndex(file);
      if (currentFileIndex2 !== -1) {
        const uploadedChunks = i + 1; // 当前已上传的分片数
        this.fileList[currentFileIndex2].name = `${file.name} （分片上传进度：${uploadedChunks}/${totalChunks})`;
        this.fileList[currentFileIndex2].percentage = Math.round((uploadedChunks / totalChunks) * 100);
        this.fileList[currentFileIndex2].uploadedChunks = uploadedChunks;
      }
      // 可选：显示上传进度
      console.log(`分片 ${currentPartNumber}/${totalChunks} 上传成功`);
    }
    
    // 再次检查是否中断（可能在最后一个分片上传后中断）
    if (controller.signal.aborted) {
      throw new Error('上传已被中断');
    }

    // 3. 合并分片// 参数：(上面接口返回) : parts:{"partNumber":1,"eTag":"6969fe670861dd98566165abcbeee01a"}
    // 上传完成后，更新为完成状态
    // 3. 合并分片
    // 使用 request API 上传,因为请求头需要Signature签名
    const mergeResponse = await request('POST', '/v1', `/ins/file/merge/${uploadId}`,partETags);
    // 这里你使用了 request API，但 mergeResponse 可能不是 Response 对象，只有使用 fetch，才能
    // if (!mergeResponse.ok) {
    //   throw new Error('合并分片失败');
    // }
    // const mergeResult = await mergeResponse.json();

    // 更新为完成状态
    const currentFileIndex3 = this.findFileIndex(file);
    if (currentFileIndex3 !== -1) {
      this.fileList[currentFileIndex3].name = `${file.name}`;  // 恢复为file.name便于删除匹配
      this.fileList[currentFileIndex3].percentage = 100;
      this.fileList[currentFileIndex3].status = 'success';
    }

    // 调用成功回调
    // this.uploadSuccess(mergeResult, file, []);
    this.uploadSuccess(mergeResponse.data, file, []);

    // 清理控制器
    delete this.uploadControllers[file.uid];

  } catch (error) {
      this.$message.error('分片上传失败');
      // 更新失败状态
      const currentFileIndex4 = this.findFileIndex(file);
      if (currentFileIndex4 !== -1) {
        this.fileList[currentFileIndex4].name = `${file.name} （上传失败）`;
        this.fileList[currentFileIndex4].percentage = 0;
        this.fileList[currentFileIndex4].status = 'fail';
      }
      this.fileList = [];
      // 清理控制器
      delete this.uploadControllers[file.uid];
  }
},
// 添加辅助方法：根据文件对象查找在fileList中的索引
findFileIndex(file) {
  return this.fileList.findIndex(item => item.rawFile === file );
},
// 添加中断上传的独立方法
abortUpload(file) {
  const fileUid = file.uid || file.rawFile?.uid;
  if (fileUid && this.uploadControllers[fileUid]) {
    console.log(`中断文件 ${file.name} 的上传`);
    this.uploadControllers[fileUid].abort();
    // 清理控制器
    delete this.uploadControllers[fileUid];
    // 更新文件状态
    const fileIndex = this.findFileIndex(file);
    if (fileIndex !== -1) {
      this.fileList[fileIndex].name = `${file.name} （已中断）`;
      this.fileList[fileIndex].status = 'fail';
      this.fileList[fileIndex].percentage = 0;
    }
    return true;
  }
  return false;
},


// ===== 其它证明材料 分片上传 =====
async chunkUpload2(file) {
  // 为当前文件创建独立的控制器
  const controller = new AbortController();
  this.uploadControllers2[file.uid] = controller;
  if (controller.signal.aborted) {
    throw new Error('上传已被中断');
  }
  try {
    // 1. 获取上传ID
    const formData1 = new FormData();
    formData1.append('fileName', file.name);
    const randomPath = Math.random().toString(36).substring(2, 9);
    const uploadIdResponse = await fetch(
      `${process.env.VUE_APP_BASEURL}/v1/ins/file/uploadId?path=register/evidence/files/${randomPath}`,
      {
        method: "POST",
        body: formData1,
        headers: this.uploadHeaders,
      }
    );
    if (!uploadIdResponse.ok) throw new Error('获取上传ID失败');

    const uploadIdData = await uploadIdResponse.json();
    const uploadId = uploadIdData.uploadId;
    console.log('其它证明材料 分片上传ID:', uploadId);

    // 2. 分片上传
    const chunkSize = 5 * 1024 * 1024;
    const totalChunks = Math.ceil(file.size / chunkSize);
    const partETags = [];

    // 在 fileList2 中添加文件项
    const fileItem = {
      name: `${file.name} （分片上传进度：0/${totalChunks})`,
      uid: file.uid,
      rawFile: file,
      status: 'uploading',
      totalChunks: totalChunks,
      uploadedChunks: 0,
      percentage: 0,
    };
    this.fileList2.push(fileItem);

    for (let i = 0; i < totalChunks; i++) {
      if (controller.signal.aborted) {
        throw new Error('上传已被中断');
      }
      const start = i * chunkSize;
      const end = Math.min(start + chunkSize, file.size);
      const chunk = file.slice(start, end);
      const currentPartNumber = i + 1;

      // 更新进度显示（上传前）
      const currentFileIndex = this.findFileIndex2(file);
      if (currentFileIndex !== -1) {
        const uploadedChunks = i;
        this.fileList2[currentFileIndex].name = `${file.name} （分片上传进度：${uploadedChunks}/${totalChunks})`;
        this.fileList2[currentFileIndex].percentage = Math.round((uploadedChunks / totalChunks) * 100);
        this.fileList2[currentFileIndex].uploadedChunks = uploadedChunks;
      }

      const formData2 = new FormData();
      formData2.append('currentPartNumber', currentPartNumber);
      formData2.append('currentPartSize', chunk.size);
      formData2.append('partNum', totalChunks);
      formData2.append('offset', start);
      formData2.append('file', chunk);

      const uploadResponse = await fetch(
        `${process.env.VUE_APP_BASEURL}/v1/ins/file/uploadPart/${uploadId}?path=register/evidence/files/${randomPath}`,
        {
          method: "POST",
          body: formData2,
          headers: this.uploadHeaders,
        }
      );
      if (!uploadResponse.ok) throw new Error(`分片 ${currentPartNumber} 上传失败`);

      const partResult = await uploadResponse.json();
      if (partResult.eTag) {
        partETags.push({ partNumber: currentPartNumber, eTag: partResult.eTag });
      }

      // 更新进度显示（上传后）
      const currentFileIndex2 = this.findFileIndex2(file);
      if (currentFileIndex2 !== -1) {
        const uploadedChunks = i + 1;
        this.fileList2[currentFileIndex2].name = `${file.name} （分片上传进度：${uploadedChunks}/${totalChunks})`;
        this.fileList2[currentFileIndex2].percentage = Math.round((uploadedChunks / totalChunks) * 100);
        this.fileList2[currentFileIndex2].uploadedChunks = uploadedChunks;
      }
      console.log(`其它证明材料 分片 ${currentPartNumber}/${totalChunks} 上传成功`);
    }

    if (controller.signal.aborted) {
      throw new Error('上传已被中断');
    }

    // 3. 合并分片
    const mergeResponse = await request('POST', '/v1', `/ins/file/merge/${uploadId}`, partETags);

    // 更新为完成状态
    const currentFileIndex3 = this.findFileIndex2(file);
    if (currentFileIndex3 !== -1) {
      this.fileList2[currentFileIndex3].name = `${file.name}`;
      this.fileList2[currentFileIndex3].percentage = 100;
      this.fileList2[currentFileIndex3].status = 'success';
    }

    // 调用成功回调
    this.uploadSuccess2(mergeResponse.data, file);

    // 清理控制器
    delete this.uploadControllers2[file.uid];

  } catch (error) {
    this.$message.error('分片上传失败');
    const currentFileIndex4 = this.findFileIndex2(file);
    if (currentFileIndex4 !== -1) {
      this.fileList2[currentFileIndex4].name = `${file.name} （上传失败）`;
      this.fileList2[currentFileIndex4].percentage = 0;
      this.fileList2[currentFileIndex4].status = 'fail';
    }
    this.fileList2 = [];
    delete this.uploadControllers2[file.uid];
  }
},

// 根据文件对象查找在 fileList2 中的索引
findFileIndex2(file) {
  return this.fileList2.findIndex(item => item.rawFile === file);
},

// 中断其它证明材料的上传
abortUpload2(file) {
  const fileUid = file.uid || file.rawFile?.uid;
  if (fileUid && this.uploadControllers2[fileUid]) {
    console.log(`中断其它证明材料 ${file.name} 的上传`);
    this.uploadControllers2[fileUid].abort();
    delete this.uploadControllers2[fileUid];
    const fileIndex = this.findFileIndex2(file);
    if (fileIndex !== -1) {
      this.fileList2[fileIndex].name = `${file.name} （已中断）`;
      this.fileList2[fileIndex].status = 'fail';
      this.fileList2[fileIndex].percentage = 0;
    }
    return true;
  }
  return false;
},

    // 上传其他证明材料
    uploadBefore2(file) {
      const allowedTypes = ['.jpg','.jpeg','.gif','.bmp','.png','.doc','.docx','.xls','.xlsx','.ppt','.pptx','.pdf','.txt','.wav','.mp4','.wmv','.mp3','.psd'];
        // 检查文件格式
        const ext = '.' + file.name.split('.').pop().toLowerCase();
        if (!allowedTypes.includes(ext)) {
            this.$message.error('不支持的文件格式：' + ext);
            return false;
        }
        // 检查文件大小
        if (file.size > 100 * 1024 * 1024) {
            this.$message.error('文件大小不能超过100MB');
            return false;
        }
        // 大于10MB使用分片上传
        if (file.size > 10 * 1024 * 1024) {
            setTimeout(() => this.chunkUpload2(file), 0);// 延迟执行，避免阻塞UI
            return false;
        }
        // 小文件：继续普通上传
        return true;
    },
    uploadExceed2(){
      this.$message.warning( '只能上传一个文件');
    },
    uploadSuccess2(response, file) {
      if(!response || !response.downloadUrl){
					this.$message.error('上传失败！');
					return false
				}
      this.form.ownershipPicture.additionalProp2 = response.downloadUrl;
      this.$refs.form.validateField('ownershipPicture.additionalProp2');
    },
    handleRemove2(file,fileList){
      // 中断该文件的上传（如果正在上传）
      this.abortUpload2(file);
      this.fileList2 = fileList;
      this.form.ownershipPicture.additionalProp2 = '';
    },
    // 预览其他证明材料放大图片
    previewImg(file){
        // console.log(file);
        let url = '';
        if(file.response){
          url = file.response.downloadUrl
        }else{
          url = file.url
        }
        document.body.style.overflow = 'hidden';
        this.showImageUrl = url;
        this.showImageViewer = true;
    },
    closePre(){
        document.body.style.overflow = 'auto';
        this.showImageUrl = '';
        this.showImageViewer = false;
    },

    // 选择作品创作类型
    selectWorksType(selectedItem){
        // console.log(selectedItem);
        this.worksTypeText = selectedItem.label;
        this.form.worksType = selectedItem.value;
      // console.log(this.constants.worksType[selectedValue].value);
      if(selectedItem.value == '16' || selectedItem.value == '17'){
        // console.log(5555);
        // 如果作品类别 为：录像制品 或 录音制品 时。rights_desc 只有  5.复制权, 6.发行权, 7.出租权 12.信息网络传播权
        this.form.rightHave = ["5", "6", "7", "12"];
      }else{
        this.form.rightHave = ["1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12", "13", "14", "15", "16", "17"];
      }
      this.$refs.form.validateField('worksType');
    },
    // 选择作品创作性质
    selectCreationNature(index){
      this.creationNatureText = this.constants.creationNature[index].label;
      this.form.creationNature = this.constants.creationNature[index].value;
      this.$refs.form.validateField('creationNature');
    },
    // 选择作品发表状态
    selectPublishStatus(index){
      this.publishStatusText = this.constants.publishStatus[index].label;
      this.form.publishStatus = this.constants.publishStatus[index].value;
      this.$refs.form.validateField('publishStatus');
      // if(index == 0 && this.form.publishTime){ // 取消发表状态，就让创作时间可以选择
      //   this.form.publishTime = ''
      // }
      // 未发表：清空发表时间、发表地点
      if (this.form.publishStatus == '1') {
        this.form.publishTime = '';
        this.form.province2 = '';
        this.form.city2 = '';
        this.areaData2 = {
          province: '',
          city: '',
        };
        // 清掉这两个字段的校验状态（因为是 v-if，字段被移除了，其实也可以不调用）
        this.$nextTick(() => {
          this.$refs.form.clearValidate(['publishTime', 'province2']);
        });
      }
    },
    handleDateChange(value){
      console.log("111:",value);
    },
    handlePaste(e, type) {
      // 1. 提取文本并暴力清洗：把中文、斜杠、点、空格全部转为标准横杠
      let s = ((e.clipboardData || window.clipboardData).getData('text') || '')
        .replace(/[年月－—–／．。]/g, '-')
        .replace(/日/g, '')
        .replace(/\s/g, '');

      // 2. 利用浏览器原生 Date 解析 (兼容 2026-10-15, 2026-10-15 12:00:00 等)
      let d = new Date(s);
      
      // 如果原生解析失败，尝试正则匹配纯数字的 20261015 格式 (防止某些极客用户粘贴纯数字)
      if (isNaN(d.getTime())) {
        const m = s.match(/^(\d{4})[-/.](\d{1,2})[-/.](\d{1,2})$/);
        if (!m) return; // 实在解析不了，直接放弃，不覆盖原有内容
        d = new Date(+m[1], +m[2] - 1, +m[3]);
      }

      // 校验非法日期（如 2026-02-30）
      if (isNaN(d.getTime())) return;

      e.preventDefault();
      const pasteTs = Number(d.getTime());// 3. 核心：强制使用 Number() 转换为数字毫秒时间戳赋值，杜绝字符串类型污染
      // 1. 不能晚于今天（包含时分秒，保证今天全天都能选）
      const todayEnd = new Date();
      todayEnd.setHours(23, 59, 59, 999);
      if (pasteTs > todayEnd.getTime()) {
        this.$message.error('日期不能晚于今天');
        return;
      }
      // ===== 极简业务逻辑校验 =====
      if (type === 'finishTime' && this.form.publishTime && pasteTs > Number(this.form.publishTime)) {
        this.$message.error('创作完成时间不能晚于首次发表时间');
        return;
      }
      if (type === 'publishTime' && this.form.finishTime && pasteTs < Number(this.form.finishTime)) {
        this.$message.error('首次发表时间不能早于创作完成时间');
        return;
      }

      this.form[type] = pasteTs;
      this.$refs.form.validateField(type);
    },

    // 选择办理时限
    changeProcessingTime(value){
      this.form.extra.processingTime = value;
      this.calAmount(); // 计算价格
    },

    // 选择支付方式
    chengePaymode(value){
      this.form.paymode = value;
    },

    // 自定义验证同意协议
    valiAgreement(rule, value, callback){
      if (!this.agreement) {
        callback(new Error("请勾选同意协议"));
        return;
      }
      callback();
    },
    registerEquirements(event){
      // 点击打开登记须知弹窗，阻止切换勾选框冒泡
      event.stopPropagation();
      event.preventDefault();
      // console.log("打开登记须知");
      this.$refs.registerEquirementsDialog.showDialog();

    },


    // 重置
    reset(){
      this.form= {
        paymode: 'vip',
        right: [],
        creationNature: "1",
        creationPropertyDesc:{
          text:"",
        },
        finishTime: "",
        creationIntention:{
          text:"",
        },
        creationProcess:{
          text:"",
        },
        province: "",
        city: "",
        publishStatus: "",
        province2: "",
        city2: "",
        publishTime: "",
        subject: "",
        worksType: "",
        files: [],
        ownership: "1",
        obtainType: "1",
        authors: [
          {name:"",signatureType:"1",signatureName:"",orders:1},
        ],
        obtainTypeDesc: {
          text:"",
        },
        ownershipPicture: {
          "additionalProp1": "",
          "additionalProp2": "",
          "additionalProp3": "",
          "additionalProp4": "",
          "additionalProp5": "",
          "additionalProp6": "",
        },
        rightHave: ["1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12", "13", "14", "15", "16", "17"],
        extra: {
          processingTime: '5',
        },
        orderType: '02',
      }
      this.worksTypeText= '',
      this.fileList= [];
      this.fileList2= [];
      this.areaData1 = {
        province: '',
        city: '',
      };
      this.areaData2 = {
        province: '',
        city: '',
      };
      this.selectObligee = null;
    },
    // 下一步
    async next(){
      this.isLoading = true;
      this.loadingText = '正在验证表单，请稍候...';
      // localStorage.removeItem(`form02_${this.mid}`); // 测试清理form缓存
        try {
          const formBaseResult = await this.$refs["form"].validate();
          
          // 先判断该订单的著作权人，是否在该平台的著作权人列表里面，检查 this.obligeeList 中是否存在至少一个 obligeeCode 匹配 this.form.right[0].obligeeCode
          const isObligeeValid = this.obligeeList.some(item => 
            item?.obligeeCode === this.form.right[0]?.obligeeCode
          );
          if (!isObligeeValid) {
            this.$message({
              type: 'warning',
              message: '著作权人错误，请重新选择！'
            });
            this.isLoading = false;
            return; // 阻止后续逻辑
          }

          // 验证 著作权人和作者不为空，且没有不同
          if(this.rightSame == "1"){ // 作者同著作权人（本名）
            if(this.form.right[0].obligeeType == '1' && this.form.authors[0].name != this.form.right[0].userName){
              this.$message({
                type: 'warning',
                message: '著作权人 或 作者信息错误，请重新选择！'
              });
              this.isLoading = false;
              return false
            }else if(this.form.right[0].obligeeType == '2' && this.form.authors[0].name != this.form.right[0].companyName){
              this.$message({
                type: 'warning',
                message: '著作权人 或 作者信息错误，请重新选择！'
              });
              this.isLoading = false;
              return false
            }
          }

          // 添加验证，如果会员权益支付，则验证会员权益支付次数是否足够
          if(this.form.paymode == 'vip'){
            if(this.vipInfo && this.vipInfo.vipType == 'C' && this.form.extra.processingTime == '15' && this.vipInfo.detectCount <= 0){
              this.$message.warning("会员权益支付登记‘15工’可用次数为0")
              this.isLoading = false;
              return false
            }else if(this.vipInfo && this.vipInfo.vipType == 'C' && this.form.extra.processingTime == '5' && this.vipInfo.registerCount <= 0){
              this.$message.warning("会员权益支付登记‘5工’可用次数为0")
              this.isLoading = false;
              return false
            }else if(this.vipInfo && this.vipInfo.vipType == 'C' && this.form.extra.processingTime == '3' && this.vipInfo.existCount <= 0){
              this.$message.warning("会员权益支付登记‘3工’可用次数为0")
              this.isLoading = false;
              return false
            }else if(this.vipInfo && this.vipInfo.vipType == 'C' && this.form.extra.processingTime == '1' && this.vipInfo.obtainCount <= 0){
              this.$message.warning("会员权益支付登记‘1工’可用次数为0")
              this.isLoading = false;
              return false
            }else if(this.vipInfo && this.vipInfo.vipType != 'C' && this.vipInfo.registerCount <= 0){
              this.$message.warning("会员权益支付可用次数为0")
              this.isLoading = false;
              return false
            }else if(!this.vipInfo){
              this.$message.warning("会员权益支付可用次数为0")
              this.isLoading = false;
              return false
            }
          }
        } catch (error) {
          // 有错误,定位到错误
          // eslint-disable-next-line
          console.error(error);
          this.mixinsScrollView();
          this.isLoading = false;
          return;
        }
        // console.log("lastform:",this.lastform);
        // console.log(this.form);
        this.stepIdx = '2'
        this.calAmount(); // 计算价格
        // this.$emit('getnext',6,this.form)
        this.isLoading = false;
    },

    // 返回修改
    prev(){
      this.stepIdx = '1'
    },

    // 提交表单
    onSubmit(submitType){
      this.isLoading = true
      this.loadingText = '正在提交，请稍候...';
      let that = this;
      // 如果是修改订单模式，检查是否有变更
      if (submitType === 'edit') {
        const currentRightCode = that.form.right[0]?.obligeeCode;
        const currentSubject = that.form.subject;
        
        // 判断著作权人或作品名称是否发生改变
        const isRightChanged = currentRightCode !== that.originalRightCode;
        const isSubjectChanged = currentSubject !== that.originalSubject;
        
        if (isRightChanged || isSubjectChanged) {
          // 清空 ownershipPicture 中的所有图片
          that.form.ownershipPicture = {
            "additionalProp3": "",
            "additionalProp4": "",
            "additionalProp5": "",
          };
          // 同时清空 fileList2 以更新UI显示
          that.fileList2 = [];
          // 可选：提示用户
          // this.$message.warning('著作权人或作品名称已变更，已清空其他证明材料');
        }
      }
      if (that.order) { // 如果已经提交过订单了，就阻止重复提交
        that.$refs.payDialog.showDialog(that.order);
        that.isPayDialogVisible = true;
        that.isLoading = false;
        return false;
      }
      let params = {
        subject: that.form.subject,
        paymode: that.form.paymode,
        // belong: that.form.ownership,
        // authors: that.form.author.map((t) => {
        //   return t.obligeeCode;
        // }),
        authors: that.form.authors,
        obligee: [that.form.right[0].obligeeCode],
        // obligee: that.form.right.map((t) => {
        //   return t.obligeeCode;
        // }),
        worksType: that.form.worksType,
        completeTime: that.form.finishTime ? Math.floor(Number(that.form.finishTime) / 1000) : null,
        publishTime: that.form.publishTime ? Math.floor(Number(that.form.publishTime) / 1000) : null,
        completeLocation: {
          province: that.form.province,
          city: that.form.city,
        },
        publishLocation: {
          province: that.form.province2,
          city: that.form.city2,
        },
        publishStatus: that.form.publishStatus,
        copyrights: that.form.rightHave,
        creationIntention: that.form.creationIntention,
        creationProperty: that.form.creationNature,
        creationProcess: that.form.creationProcess,
        creationPropertyDesc: that.form.creationPropertyDesc,
        items: that.form.files,
        obtainType: that.form.obtainType,
        obtainTypeDesc: that.form.obtainTypeDesc,
        ownershipPicture: that.form.ownershipPicture,
        signatureType: that.form.signatureType,
        extra: that.form.extra,
        orderType: that.form.orderType,
      };
      console.log('提交params----：',params);
      //  register 正常登记， edit 修改订单
      if(submitType == 'register'){   // 正常登记
        applyRegisterOrder(params).then(({ data }) => {
          that.order = data;
          console.log("order::::::::::::",that.order);
          if (data.paymentStatus == "21") {
            that.bus.$emit("refreshVip");
            that.onSetPayDialogClose(true);
            // console.log('登记-支付成功，删除本地储存form'); 
            localStorage.removeItem(`form02_${this.mid}`);
          } else {
            that.$refs.payDialog.showDialog(data);
            that.isPayDialogVisible = true;
          }
          that.isLoading = false
        }).catch(error => {
          that.isLoading = false;
        });
      }else if(submitType == 'edit'){   // 修改订单
        editRegister(this.orderNo,params).then(({ data }) => {
          that.order = data;
          console.log("order::::::::::::",that.order);
          if (data.paymentStatus == "21") {
            that.bus.$emit("refreshVip");
            that.onSetPayDialogClose(true);
            // console.log('登记-支付成功，删除本地储存form');
            localStorage.removeItem(`form02_${this.mid}`);
          } else {
            that.$refs.payDialog.showDialog(data);
            that.isPayDialogVisible = true;
          }
          that.isLoading = false
        }).catch(error => {
          that.isLoading = false;
        });
      }
      
    },
    onSetPayDialogClose(result) {
      console.log(result);
      if (result) {
        //跳转至详情页
        this.$router.push({
          path: "/Register/Detail",
          query: { orderNo: this.order.orderNo },
        });
      }
    },

    // 多图拼接
    handleOpenCollageDialog(){
      if (!this.form.subject || this.form.subject.trim() === '') {
        this.$message.warning('请先填写作品名称');
        return;
      }
      this.showCollageDialog = true;
    },
    handleUseCollage(imageData) {
      // console.log('收到拼图数据:', imageData);
      // 关闭弹窗
      this.showCollageDialog = false;
      // 可以在这里将图片数据用于其他业务逻辑
      // 例如：保存到数据库、设置为头像、添加到编辑器等
      // this.$message.success('拼图已使用！');
      // 将 base64 转换为 File 对象
      const base64ToFile = (base64Data, filename) => {
        const arr = base64Data.split(',');
        const mime = arr[0].match(/:(.*?);/)[1];
        const bstr = atob(arr[1]);
        let n = bstr.length;
        const u8arr = new Uint8Array(n);
        while (n--) {
          u8arr[n] = bstr.charCodeAt(n);
        }
        return new File([u8arr], filename, { type: mime });
      };
      // const fileName = `collage_${Date.now()}.png`;
      const fileName = this.form.subject + `.png`;
      const file = base64ToFile(imageData, fileName);

      // ===== 新增：大文件直接走分片上传 =====
      if (file.size > 10 * 1024 * 1024) {
        // chunkUpload 内部会 push 到 fileList 并最终调 uploadSuccess
        this.chunkUpload(file);
        return;
      }
      
      // 创建 FileList 类似对象并触发上传组件的 input change 事件
      const dataTransfer = new DataTransfer();
      dataTransfer.items.add(file);
      
      // 找到上传组件的 input 元素并触发 change 事件
      const uploadInput = document.querySelector('.uploadWraper .el-upload__input');
      if (uploadInput) {
        uploadInput.files = dataTransfer.files;
        const event = new Event('change', { bubbles: true });
        uploadInput.dispatchEvent(event);
      }
    },
    handleClose() {
      this.showCollageDialog = false;
    },


    // 付费通知弹窗相关
    handleViewDetail() {
      const routeUrl = this.$router.resolve({
        name: 'PaymentNotification',
      })
      // 在新窗口打开
      window.open(routeUrl.href, '_blank')
      // 关闭 alert
      this.showAlert = false
    },
    
    // 点击右上角关闭按钮的处理
    alertClose() {
      this.showAlert = false
    }

  },
  beforeDestroy() {
    // 中断所有 作品上传 的分片上传
    Object.keys(this.uploadControllers).forEach(uid => {
      this.uploadControllers[uid].abort();
    });
    this.uploadControllers = {};
    // 中断所有 其它证明材料 的分片上传
    Object.keys(this.uploadControllers2).forEach(uid => {
      this.uploadControllers2[uid].abort();
    });
    this.uploadControllers2 = {};
  },

};
</script>

<style lang='scss' scoped>
@import "../../../assets/css/inputForm.scss";
.commonWhiteBg {
  min-height: 800px;
  /deep/ .ant-popover-arrow {
    left: 30%;
  }
  .title {
    font-size: 24px;
    margin-bottom: 24px;
    font-weight: bold;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .formTitle{
    font-family: 'PingFangSC, PingFang SC';
    font-weight: 500;
    font-size: 18px;
    color: rgba(0,18,22,0.85);
    line-height: 40px;
    padding: 0 15px;
    border-bottom: 1px solid #E2E5EA;
    position: relative;
  }
  .formTitle::before{
    content: '';
    width: 3px;
    height: 18px;
    background: #1C67E7;
    border-radius: 2px;
    position: absolute;
    left: 0;
    top: 11px;
  }
  .formTitle2::before{
    display: none;
  }
  .rightText{
    max-width: 140px;
    display: inline-block;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .el-form-item {
    margin: 12px 0;
    display: flex;
    align-items: inherit;
  }
  /deep/.el-form-item__label{
    font-family: 'PingFangSC, PingFang SC';
    font-weight: 500;
    font-size: 14px;
    color: rgba(0,18,22,0.85);
    line-height: 32px;
    padding-right: 12px;
  }
  /deep/.el-form-item__content{
    width: calc(100% - 125px);
    line-height: 32px;
    margin-left: 0!important;
    display: flex;
    align-items: inherit;
    .el-button{
      height: 32px;
      line-height: 32px;
      padding: 0;
    }
    .el-button:disabled{
      color: #C3C7CF;
      i{
        color: rgba(0,0,0,0.2);
      }
    }
    .el-input__inner{
      height: 32px;
      line-height: 32px;
      font-size: 14px;
      color: #001216;
      padding: 0 12px;
    }
    .el-input__inner:disabled{
      color: #C3C7CF;
    }
    .el-radio{
      height: 32px;
      line-height: 32px;
    }
    .el-select{
      height: 32px;
      line-height: 32px;
    }
    .el-input__icon{
      line-height: 32px;
    }
    .el-input__prefix {
        left: auto;
        right: 6px;
    }
    .el-radio__original {
      display: none !important;
    }

    .el-radio:focus:not(.is-focus):not(:active):not(.is-disabled) .el-radio__inner {
      box-shadow: none !important;
    }
  }
  .el-upload{
    .el-button{
      padding: 0 12px;
      background: #FFFFFF;
      border-radius: 2px;
      border: 1px solid rgba(0,0,0,0.15);
      color: rgba(0,0,0,0.65);
      i{
        font-size: 14px;
        margin-right: 6px;
        color: rgba(0,0,0,0.45);
      }
    }
  }
  .mergeImagesBtn{
    margin-left: 10px;
    padding: 0 12px!important;
    background: #FFFFFF;
    border-radius: 2px;
    border: 1px solid rgba(0,0,0,0.15);
    color: rgba(0,0,0,0.65);
    i{
      font-size: 14px;
      margin-right: 6px;
      color: rgba(0,0,0,0.45);
    }
  }

  /deep/ .mergeImagesDialog .el-dialog__body {
    padding: 0 !important;
  }

  .tipsText{
    font-family: 'PingFangSC, PingFang SC';
    font-size: 14px;
    color: #89909B;
    line-height: 32px;
    padding: 0 10px;
  }
  /deep/.linkage div{
    width: calc(50% - 6px);
    height: 32px;
    .el-select{
      width: 100%;
      .el-input{
        width: 100%;
      }
    }
  }
  /deep/.el-textarea__inner{
    padding: 5px 12px;
  }
  .ant-alert-with-description.ant-alert-no-icon{
    padding: 5px 12px;
    margin: 12px 0 12px 12px;
  }
  .ant-alert-with-description{
    color: rgba(0, 18, 22, 0.50);
    /deep/.ant-alert-message{
      color: rgba(0, 18, 22, 0.65);
      margin-bottom: 2px;
    }
    /deep/.ant-alert-description{
      line-height: 20px;
    }
  }
  .bigPrice{
    font-size: 22px;
    line-height: 32px;
  }
  .submitRow{
    .el-button{
      width: 180px;
      margin-left: 125px;
    }
    .el-button:nth-child(2){
      margin-left: 40px;
    }
  }

  .el-upload-list__item:hover .el-upload-list__item-delete{
    display: block;
    cursor: pointer;
  }

}
/deep/{
  .el-radio__label,.el-checkbox__label{color: rgba(0,0,0,0.65)!important;}
  .el-checkbox__label span{color: #007DFF;}
}
/deep/.el-checkbox-group{line-height: 20px;}
/deep/.el-checkbox{white-space: inherit;display: flex;align-items: center;}

.alert-content {
  width: 100%;
}
.alert-title {
  font-weight: 500;
  margin-bottom: 8px;
  font-size: 14px;
}
.alert-desc {
  font-size: 14px;
  line-height: 1.6;
  color: rgba(0, 0, 0, 0.65);
}

.detail-btn {
  border: none;
  border-radius: 0;
  padding: 0;
  height: 20px;
  line-height: 20px;
  border-bottom: 1px solid #007DFF;
}

// 适配移动端
@media screen and (max-width: 991px){
  /deep/.commonWhiteBg .el-form-item__content{
    display: block;
    .el-button{display: block;}
    .el-radio{height: auto;}
  }
}
</style>
